/**
 * @fileoverview GET handler for the "/data_objects/data_objects_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUsage } from "./constants";
import type { CustomObjectsUsageResult } from "./types";
import { isCustomObjectsUsageResult } from "./validators";

export const getCustomObjectsUsage = reactQueryFetcherAdapter(
  customObjectsUsage,
  (signal: AbortSignal): Promise<CustomObjectsUsageResult> => {
    return fetch("/data_objects/data_objects_usage", "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isCustomObjectsUsageResult
);
